module.exports = __webpack_public_path__ + "35ae96a0c817d3ef137c587d111632c9.png";